/* ============================================================
   Laley PDP Clean v4 — boot
   Modulær PDP-runtime. Den gamle v3-monolitten er kun historisk arkiv.
   Init av alle [data-pdp-section] + shopify:section:load/unload.
   MÅ lastes sist — alle moduler skal være registrert før init.
   ============================================================ */
(() => {
  const PDP = window.LaleyPDPCleanV4;
  if (!PDP) {
    console.error('[PDP] Kjerne mangler — PDP boot avbrutt');
    return;
  }
  const REQUIRED_MODULES = ["variants","siblings","reviews","commerce","bundle","gallery","sticky","product-ui"];
  const missing = REQUIRED_MODULES.filter((name) => !PDP.modules.includes(name));
  if (missing.length) console.warn('[PDP] Moduler mangler ved boot: ' + missing.join(', '));

  const { SECTION_SELECTOR, instances, LaleyPDP } = PDP;
  const primeReviewFallback = PDP.hooks.primeReviewFallback || (() => {});

  const initSection = (section) => {
    if (!section || instances.has(section)) return;
    primeReviewFallback(section);
    const instance = new LaleyPDP(section);
    instances.set(section, instance);
    instance.init();
  };

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.(SECTION_SELECTOR) ? event.target : event.target.querySelector?.(SECTION_SELECTOR);
    initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.(SECTION_SELECTOR) ? event.target : event.target.querySelector?.(SECTION_SELECTOR);
    const instance = section ? instances.get(section) : null;
    if (instance) instance.destroy();
  });
})();
